import { HttpApiSchema } from "@effect/platform";
import { Schema } from "effect";

export const CUSTOM_EMAIL_FREE_MAIL_DOMAIN_MESSAGE =
  "Use an address on a domain you own, like support@yourstore.com. Free email providers like Gmail can't be used to send support email.";

/** A custom email sender on a free-mail domain (gmail.com and the like), which nobody but the provider can publish DNS for. */
export class CustomEmailFreeMailDomainError extends Schema.TaggedError<CustomEmailFreeMailDomainError>()(
  "CustomEmailFreeMailDomainError",
  {},
  HttpApiSchema.annotations({ status: 400 }),
) {}
